// extracted by mini-css-extract-plugin
export var buttonContent = "_22-0";
export var centered = "_22-1";
export var centeredFlex = "_22-2";
export var errorText = "_22-3";
export var icon = "_22-4";
export var iconButtonContent = "_22-5";
export var monospace = "_22-6";
export var padded = "_22-7";